import { render, staticRenderFns } from "./Forms.vue?vue&type=template&id=24487e85&"
import script from "./Forms.vue?vue&type=script&lang=js&"
export * from "./Forms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\yuichi\\git\\open_coupon\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24487e85')) {
      api.createRecord('24487e85', component.options)
    } else {
      api.reload('24487e85', component.options)
    }
    module.hot.accept("./Forms.vue?vue&type=template&id=24487e85&", function () {
      api.rerender('24487e85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/Forms.vue"
export default component.exports